<ngx-extended-pdf-viewer class="layer" [src]="orcamento" [height]="'auto'" [filenameForDownload]="'orcamento_' + id + '.pdf'"
  [showToolbar]="true" [showZoomButtons]="true" [showPrintButton]="true" [showDownloadButton]="true"
  [showSidebarButton]="true" [showSecondaryToolbarButton]="false" [showFindButton]="false" [showPagingButtons]="false"
  [showDrawEditor]="false" [showStampEditor]="false" [showTextEditor]="false" [showPresentationModeButton]="false"
  [showOpenFileButton]="false" [showRotateButton]="false" [showHandToolButton]="false" [showSpreadButton]="false"
  [showPropertiesButton]="false" [pageLabel]="pageLabel" >
</ngx-extended-pdf-viewer>

<div style="position: absolute; z-index: 1000; bottom: 50px; right: 50px;">
  <button class="btn no-print btn-success btn-block" (click)="abrirModalEmail(modalImprimir)">
    Enviar no Email
  </button>
</div>

<ng-template #modalImprimir let-modal>
  <div class="modal fade show d-block" tabindex="-1" style="z-index: 1050; background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Cabeçalho -->
        <div class="modal-header">
          <h5 class="modal-title">Enviar {{ "Orçamento" | translate }}</h5>
          <button type="button" class="close" aria-label="Close" (click)="fecharModalEmail()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Corpo do Modal -->
        <div class="modal-body">
          <form #form="ngForm" (ngSubmit)="EnviarOrcamento()" novalidate>

            <!-- Erros -->
            <div class="alert alert-danger" *ngIf="errors">
              <ul>
                <li *ngFor="let erro of errors">{{ erro }}</li>
              </ul>
            </div>

            <!-- Sucesso -->
            <div class="alert alert-success" *ngIf="success">
              <p>{{ success }}</p>
            </div>

            <!-- Campo de E-mail -->
            <div class="form-group">
              <label for="email">E-mail</label>
              <input id="email" name="email" type="email" class="form-control"
                placeholder="{{ 'Informe o E-mail' | translate }}" [(ngModel)]="email" [disabled]="loadingEnvio"
                required>
            </div>

            <!-- Botão Enviar -->
            <div class="form-group mt-4">
              <button type="submit" class="btn btn-primary btn-block" [disabled]="!form.valid || loadingEnvio">
                Enviar {{ "Orçamento" | translate }}
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</ng-template>